import Vue from 'vue'
import Element from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'
import i18n from '../i18n'
import './element.scss'

//ElementUI配置
Vue.use(Element, { zIndex: 3000 })

//国际化配置
ElementLocale.i18n((key, value) => i18n.t(key, value))